import axios from "@/api/axios";

const getConfig = (data) => {
    return axios
        .post('/admin/config', data)
        .then(response => response.data)
}

export default {
    getConfig
}